import { DropdownMenuGroup } from '../../../../core'
import { RestrictToCapability } from '../../../components/RestrictToCapability'
import { useLeaveFeedbackContext } from './LeaveFeedbackProvider'
import { LeaveFeedbackDropdownMenuItem } from './LeaveFeedbackMenuItems'
import { useProposeChangeContext } from './ProposeChangeContext'
import { ProposeChangeDropdownMenuItem } from './ProposeChangeMenuItems'

export function HelpActionMenuItems() {
  const leaveFeedbackContext = useLeaveFeedbackContext()
  const proposeChangeContext = useProposeChangeContext()

  return (
    <DropdownMenuGroup>
      <LeaveFeedbackDropdownMenuItem
        onLeaveFeedback={leaveFeedbackContext.actions.openFeedbackDialog}
      />
      <RestrictToCapability capability="product_change.propose">
        <ProposeChangeDropdownMenuItem
          onProposeChange={proposeChangeContext.actions.openProposeChangeDialog}
        />
      </RestrictToCapability>
    </DropdownMenuGroup>
  )
}
